module.exports = __webpack_public_path__ + "media/images/mail-facebook-cb8a1c05b31410388e2581a5c235ecd4.png";